import { DEVELOPMENT, PRODUCTION, STAGING } from '../constants/envs';
import { CONSOLIDATING, DEVELOPING, EARLY, EMERGENT, EXTENDING } from '../constants';

export const isDev = (): boolean => DEVELOPMENT === process.env.REACT_APP_ENV;

export const isStaging = (): boolean => STAGING === process.env.REACT_APP_ENV;

export const isProd = (): boolean => PRODUCTION === process.env.REACT_APP_ENV;

export const getAvailableStages = (): string[] =>
  [EMERGENT, EARLY, DEVELOPING, CONSOLIDATING, EXTENDING].filter(stage => getStageAvailability(stage));

export const getStageAvailability = (stage: string): boolean =>
  ({
    [EMERGENT]: process.env.REACT_APP_EMERGENT_STAGE,
    [EARLY]: process.env.REACT_APP_EARLY_STAGE,
    [DEVELOPING]: process.env.REACT_APP_DEVELOPING_STAGE,
    [CONSOLIDATING]: process.env.REACT_APP_CONSOLIDATING_STAGE,
    [EXTENDING]: process.env.REACT_APP_EXTENDING_STAGE,
  }[stage] === 'true');

export const getLessonAvailability = (stage: string): boolean =>
  ({
    [EMERGENT]: process.env.REACT_APP_EMERGENT_LESSON,
    [EARLY]: process.env.REACT_APP_EARLY_LESSON,
    [DEVELOPING]: process.env.REACT_APP_DEVELOPING_LESSON,
    [CONSOLIDATING]: process.env.REACT_APP_CONSOLIDATING_LESSON,
    [EXTENDING]: process.env.REACT_APP_EXTENDING_LESSON,
  }[stage.toLowerCase()] === 'true');
